import React, { useState } from 'react'
import { Toast } from 'react-bootstrap'
import styled from 'styled-components';
import branding from '../../branding/branding';
import { mapErrorsToString } from '../../utils/Errors';

const Wrapper = styled.div`
    .success{
        background-color: rgb(112, 173, 71);
    }
    .error{
        background-color: #EF4444;
    }
    .warning{
        background-color: #F59E0B;
    }
`

function notificationType(type: string) {
    switch (type) {
        case 'error':
            return 'error';
        case 'warning':
            return 'warning';
        case 'success':
            return 'success';
        default:
            return '';
    }
}

interface NotificationProps {
    type: string
    title: string
    text: string
}

const Notification: React.FC<NotificationProps> = ({ type, title, text }) => {
    const [show, setShow] = useState(true);
    return (
        <Wrapper>
            <Toast className={notificationType(type)} show={show} delay={branding.configuration.modalPublish.visibilityDuration} autohide onClose={() => setShow(false)}>
                <Toast.Header>
                    <strong className="me-auto">{title}</strong>
                </Toast.Header>
                <Toast.Body>{mapErrorsToString(text)}</Toast.Body>
            </Toast>
        </Wrapper>
    )
}

export default Notification